<template>
  <div>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <label class="input-group-text" for="repeat_option">Repeat</label>
      </div>
      <select class="w-full" id="repeat_option" :value="repeatOption.type"
              @change="updateRepeatOption($event)">

        <option v-for="option in options" :value="option.value" :key="option.value">{{ option.name }}</option>
      </select>
    </div>

    <div v-if="repeatOption.type === 'every_week'" class="mb-2">
      <label>Repeat on</label>
      <div>

        <div>
          <label v-for="(date,key) in weekDayCheckBox" :key="key">
            <input type="checkbox" :value="date.value" v-model="repeatOption.everyWeekPicker"
                   @change="updateWeekDayOption($event)">
            <span>{{ date.name }}</span>
          </label>
        </div>

      </div>
    </div>

    <div>
      <label>At</label>
      <div class="input-group mb-3">
        <time-picker  @change="updateRepeatAt" style="width: 100%;" use12-hours format="h:mm:ss A"></time-picker>
      </div>


      <label>Timezone</label>
      <a-select
          ref="select"
          v-model:value="timezone"
          placeholder="Please select a timezone"
          style="width: 100%;"
          :options="timezones"
          @change="handleChange"
      >
      </a-select>


    </div>
  </div>
</template>

<script>
import {TimePicker} from 'ant-design-vue';
import {defineComponent, ref, onMounted} from 'vue';

export default {
  props: ['modelValue'],
  components: {
    TimePicker
  },
  setup() {

    const timezones = ref([]);
    const timezone = ref(null);

    function getTimezoneList() {
      window.axios.get(route('standup.getTimezones'))
          .then(function (response) {
            timezones.value = response.data.timezones;
          })
          .catch(function (error) {

          });
    }

    const handleChange = (value) => {
      timezone.value = value;
    };

    onMounted(() => {
      getTimezoneList();
    });

    return {
      timezone,
      timezones,
      handleChange
    };
  },
  watch: {

    timezone: function (val) {
      this.repeatAt.timezone = val;
      this.emitModel();
    },
  },

  data() {
    return {
      options: [
        {
          name: 'every week',
          value: 'every_week'
        },
        {
          name: 'every day',
          value: 'every_day'
        }
      ],
      everyWeekModel: {
        type: 'every_week',
        everyWeekPicker: ['1', '2', '3', '4', '5', '6', '7']
      },
      everyDayModel: {
        type: 'every_day',
      },
      repeatOption: {
        type: 'every_day',
      },
      repeatAt: {
        time: '10:00',
        timezone: 'user'
      },
      weekDayCheckBox: [
        {
          name: 'Mon',
          value: '1',
          full_name: 'Monday'
        },
        {
          name: 'Tue',
          value: '2',
          full_name: 'Tuesday'
        },
        {
          name: 'Wed',
          value: '3',
          full_name: 'Wednesday'
        },
        {
          name: 'Thu',
          value: '4',
          full_name: 'Thursday'
        },
        {
          name: 'Fri',
          value: '5',
          full_name: 'Friday'
        }
        , {
          name: 'Sat',
          value: '6',
          full_name: 'Saturday'
        },
        {
          name: 'Sun',
          value: '7',
          full_name: 'Sunday'
        },
      ]
    }
  },
  computed: {},
  methods: {
    async getTimezoneList() {
      let app = this;
      await window.axios.get('/web/apps/agile-bot/timezones')
          .then(function (response) {
            app.timezones = response.data.timezones;
          })
          .catch(function (error) {

          });
    },
    updateRepeatAt(d) {
      this.repeatAt.time = d.format('H:mm:ss');
      this.emitModel();
    },
    emitData(data) {
      this.$emit('update:modelValue', data);
    },
    updateWeekDayOption() {
      this.repeatOption.everyWeekPicker.sort();
      this.emitModel();
    },
    updateRepeatOption(event) {

      switch (event.target.value) {
        case 'every_week': {
          this.repeatOption = {...this.everyWeekModel};
          break;
        }
        case 'every_day': {
          this.repeatOption = {...this.everyDayModel};
          break;
        }
      }
      this.emitModel();
    },
    emitModel() {
      this.emitData(
          {
            repeatOption: {...this.repeatOption},
            repeatAt: {...this.repeatAt}
          }
      )
    },
    init() {
      if (!this.value) {
        this.repeatOption = {...this.everyWeekModel};
        this.timezone = this.value.repeatAt.timezone;
        this.emitModel();
      } else {
        this.repeatOption = {...this.value.repeatOption};
        this.repeatAt = {...this.value.repeatAt};
        this.timezone = this.value.repeatAt.timezone;
      }
    }
  },
  created() {
    this.getTimezoneList();
  },
  mounted() {
  }
}
</script>


<style scoped>

input[type=checkbox] {
  display: none;
}

label :checked + span {
  background: #66bb6a;
  color: white;
}

label span {
  display: inline-block;
  background: lightgrey;
  height: 3em;
  width: 3em;
  line-height: 3em;
  text-align: center;
  border-radius: 50%;
  cursor: pointer;
  margin-right: 2px;
}

.round {
  position: relative;
}

.round label {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 50%;
  cursor: pointer;
  height: 28px;
  left: 0;
  position: absolute;
  top: 0;
  width: 28px;
}

.round input[type="checkbox"] {
  visibility: hidden;
}

.round input[type="checkbox"]:checked + label {
  background-color: #66bb6a;
  border-color: #66bb6a;
}

.round input[type="checkbox"]:checked + label:after {
  opacity: 1;
}


</style>